module.exports = __webpack_public_path__ + "media/images/home/free_transportation_to_and_from_storage-64dfa0f8bd1a7050577312dd165d5068.svg";